import { EPublishOfferStatus, IPublishOfferSuccessPayload } from '../types';
import { IPublishOfferSuccessResponse } from '../../../repositories/monolith-python/v2/publish-offer';
import { mapErrors } from './mapErrors';

export const mapPublishOfferData = (response: IPublishOfferSuccessResponse): IPublishOfferSuccessPayload => {
  const {
    id,
    status,
    errors,
    redirectUrl = null,
  } = response || {};

  return {
    id,
    status: (status as string as EPublishOfferStatus),
    errors: mapErrors(errors),
    redirectUrl,
  };
};
